(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knowledge-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const input = document.getElementById('hub-search-input');
    const results = document.getElementById('hub-search-results');
    if (!input || !results) return;

    const msgNoResults = (document.documentElement.lang || '').toLowerCase().slice(0, 2) === 'en' ? 'No results' : 'Keine Ergebnisse';
    const bztRoot = (typeof window.BZT_ROOT === 'string') ? window.BZT_ROOT : ((location.pathname.match(/^\/(en|de-eu|en-eu)(?=\/|$)/) || [''])[0]);
    let controller = null;
    let activeIndex = -1;

    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function debounce(fn, wait) {
      let t;
      return function () {
        clearTimeout(t);
        const args = arguments;
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    async function runSearch(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = bztRoot + '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=article&resources[limit]=6&resources[options][unavailable_products]=last';
      try {
        const res = await fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } });
        const data = await res.json();
        const articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
        render(articles, q);
      } catch (e) {
        if (e.name !== 'AbortError') clearResults();
      }
    }

    function render(articles, q) {
      if (!articles.length) {
        results.innerHTML = '<span class="hub-search__state">' + msgNoResults + '</span>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      results.innerHTML = articles.map((a, i) => {
        const title = a.title || '';
        return '<a class="hub-search__result" role="option" id="hub-sr-' + i + '" href="' + a.url + '">' +
          '<span class="hub-search__result-title">' + title + '</span>' +
          '</a>';
      }).join('');
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    const onInput = debounce(function () {
      const q = input.value.trim();
      if (q.length < 2) { clearResults(); return; }
      runSearch(q);
    }, 180);

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (e) {
      const items = results.querySelectorAll('.hub-search__result');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = (activeIndex + 1) % items.length;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = (activeIndex - 1 + items.length) % items.length;
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) { window.location.href = items[activeIndex].href; }
        return;
      } else if (e.key === 'Escape') {
        clearResults();
        return;
      } else {
        return;
      }
      items.forEach((el, i) => el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));
      if (items[activeIndex]) input.setAttribute('aria-activedescendant', items[activeIndex].id);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hub-search')) clearResults();
    });
  })();

  /* Cluster-Unterkategorie-Filter: Chips zeigen/verbergen Sektionen */
  (function () {
    const filter = document.getElementById('hub-subfilter');
    const container = document.getElementById('hub-cluster-sections');
    if (!filter || !container) return;

    const chips = filter.querySelectorAll('.hub-subfilter__chip');
    const sections = container.querySelectorAll('.hub-subsection');

    filter.addEventListener('click', function (e) {
      const chip = e.target.closest('.hub-subfilter__chip');
      if (!chip) return;
      const f = chip.dataset.filter;

      chips.forEach((c) => {
        const active = c === chip;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      sections.forEach((sec) => {
        if (f === 'all') {
          sec.hidden = false;
          sec.querySelectorAll('.hub-subsection__title').forEach((t) => { t.style.display = ''; });
          return;
        }
        const matches = sec.dataset.group === f;
        sec.hidden = !matches;
        if (matches) {
          sec.querySelectorAll('.hub-subsection__title').forEach((t) => { t.style.display = 'none'; });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
